import React, { Component, cloneElement } from 'react';
import { string, arrayOf, element, shape, any } from 'prop-types';
import { Avatar } from '@material-ui/core';

import styles from './styles.scss';
import classnames from 'classnames';

export default class CompactUserInfo extends Component {
  static propTypes = {
    firstName: string,
    lastName: string,
    subtitle: string,
    badges: arrayOf(element),
    profileImage: string,
    avatarColors: arrayOf(string),
    classes: shape({any}),
    avatarSize: string,
    avatarFontSize: string,
    avatarIcon: element,
    iconAvatarColor: string
  }

  static defaultProps = {
    firstName: '',
    lastName: '',
    avatarSize: '38px',
    avatarFontSize: '18px',
    avatarColors: ['#67B7DC','#6794DC', '#67A1DC', '#8087DC', '#A397DC', '#C787DC'],
    iconAvatarColor: '#E0E0E0'
  }

  genAvatorImg() {
    const { 
      firstName, 
      lastName, 
      profileImage, 
      avatarSize, 
      avatarFontSize, 
      avatarColors, 
      avatarIcon, 
      iconAvatarColor 
    } = this.props;
    const firstNameInitial = firstName.charAt(0);
    const lastNameInitial = lastName.charAt(0);
    const displayName = `${firstNameInitial}${lastNameInitial}`.toUpperCase();
    const colorIndex = (firstNameInitial.charCodeAt() + lastNameInitial.charCodeAt()) % avatarColors.length;
    const backgroundColor = avatarIcon? iconAvatarColor : avatarColors[colorIndex];
    const avatarStyle = {
      width: avatarSize,
      height: avatarSize,
      fontSize: avatarFontSize,
      backgroundColor
    }
    return (
      <Avatar className={styles.avatarImg} src={profileImage} style={avatarStyle} >
        { avatarIcon? cloneElement(avatarIcon): displayName}
      </Avatar>
    ) 
  }
  
  render() {
    const { firstName, lastName, subtitle, badges, classes } = this.props;
    return (
      <div className={classnames(styles.compactUserInfoContainer, classes)}>
        <div data-test="compactUserAva" className={styles.avatorContainer}>{this.genAvatorImg()}</div>
        <div className={styles.userInfoContainer}>
          <div className={styles.userInfo}>
            <div data-test="compactUserName" className={styles.userName}>{firstName} {lastName}</div>
            <div data-test="compactUserBadges" className={styles.userBadge}>{badges}</div>
          </div>
          <div data-test="compactUserSubtitle" data-cy={subtitle} className={styles.subtitleContainer}>{subtitle}</div>
        </div>
      </div>
    )
  }
}
